import { List } from '@mui/material';
import EventStatusDetail from './EventStatusDetail';
import { EventUploadDetails } from '../../../model/event-upload-details';

interface IProps {
  eventUploadDetailsList: EventUploadDetails[];
  groupPicturesExpected: boolean;
}

function EventStatusDetailsList({ eventUploadDetailsList, groupPicturesExpected }: IProps) {
  return (
    <>
      {eventUploadDetailsList?.map((eventUploadDetails, index) => (
        <div key={'Day_' + index}>
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <EventStatusDetail eventUploadStatus={eventUploadDetails}
            groupPicturesExpected={groupPicturesExpected}
            />
          </List>
        </div>
      ))}
    </>
  );
}

export default EventStatusDetailsList;
